import { useMainMachine } from '../../../utils/useMainMachine';
import { inflect } from '../../../utils/string';

export function WordsChanged() {
  const { useSelector } = useMainMachine();
  const wordsChanged = useSelector(({ context }) => context.wordsChanged);
  const imagesChanged = useSelector(({ context }) => context.imagesChanged);

  return (
    <div className="ml-5 text-gray-200 whitespace-pre" data-testid="words-changed">
      {wordsChanged} {inflect('word', wordsChanged)}
      {` and ${imagesChanged} ${inflect('image', imagesChanged)}`} changed
    </div>
  );
}
